/**
 * Returns an error to be thrown when attempting to find an unexisting column.
 * \@docs-private
 * @param {?} id Id whose lookup failed.
 * @return {?}
 */
export function getTableUnknownColumnError(id) {
    return Error(`cdk-table: Could not find column with id "${id}".`);
}
/**
 * Returns an error to be thrown when two column definitions have the same name.
 * \@docs-private
 * @param {?} name
 * @return {?}
 */
export function getTableDuplicateColumnNameError(name) {
    return Error(`cdk-table: Duplicate column definition name provided: "${name}".`);
}
/**
 * Returns an error to be thrown when there are multiple rows that are missing a when function.
 * \@docs-private
 * @return {?}
 */
export function getTableMultipleDefaultRowDefsError() {
    return Error(`cdk-table: There can only be one default row without a when predicate function.`);
}
/**
 * Returns an error to be thrown when there are no matching row defs for a particular set of data.
 * \@docs-private
 * @return {?}
 */
export function getTableMissingMatchingRowDefError() {
    return Error(`cdk-table: Could not find a matching row definition for the provided row data.`);
}
//# sourceMappingURL=table-errors.js.map